import { FormValidators } from '@servicetitan/form-state';
import { MultipleValidator } from './multiple.validator';

export const isEmail = (val: string) => FormValidators.emailFormatIsValid(val) && val.length < 255;

export const validEmailMessage = 'Enter a valid email address';
export const validEmailFormatMessage = 'Enter a valid email format';

export const requiredEmailFieldValidator =
    FormValidators.requiredWithCustomMessage('Enter an email');

export const emailFieldValidator = (val: string) => !isEmail(val) && validEmailMessage;

export const createEmailValidator = () =>
    new MultipleValidator({
        'Can be an email': () => false,
        [validEmailMessage]: val => !isEmail(val),
        [validEmailFormatMessage]: val => {
            const values = val.split('@');
            return (
                isEmail(val) &&
                (values.length !== 2 || values[0].length > 60 || values[1].length > 255)
            );
        },
    });
